export class RedirectError extends Error {
  constructor(public readonly url: string) {
    super();
    this.name = 'RedirectError';
    this.cause = url;
  }
}
